export default "__VITE_ASSET__C4OWZcj5__"